// processMotorToolConstants — pure constants + type-guards extracted
// från processMotorTools.ts så server-pure libs (aiToolCallStream)
// kan importera utan att dra in runTrigger → supabase-client.
//
// Side-effekts-bärande dispatch:s bor kvar i processMotorTools.ts.

export type ProcessMotorToolName =
  | 'trigger_workflow_run'
  | 'list_recent_workflow_runs';

/** Valid tool-names för type-guard. */
export const PROCESS_MOTOR_TOOL_NAMES: readonly ProcessMotorToolName[] = [
  'trigger_workflow_run',
  'list_recent_workflow_runs',
];

export function isProcessMotorTool(name: string): name is ProcessMotorToolName {
  return PROCESS_MOTOR_TOOL_NAMES.includes(name as ProcessMotorToolName);
}

/** Indikerar om tool:en skriver state — caller ska ha approval. */
export function requiresApproval(name: ProcessMotorToolName): boolean {
  return name === 'trigger_workflow_run';
}
